module.exports = __webpack_public_path__ + "img/icon_generator.89fe0b7a.png";